import { useSnackbar } from '@focaldata/cin-ui-components'

export type EnqueueSnackbar = ReturnType<typeof useSnackbar>['enqueueSnackbar']

/**
 * useSnackbar() throws when a component is rendered outside a SnackbarProvider
 * (the provider only wraps the app root, so many unit tests render without it).
 * Returns `undefined` in that case so shared hooks can surface toasts without
 * forcing every test to wrap SnackbarProvider. Mirrors the guard in
 * useGetDraftQuestionnaire. Call the result with optional chaining.
 */
export const useSafeEnqueueSnackbar = (): EnqueueSnackbar | undefined => {
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useSnackbar().enqueueSnackbar
  } catch {
    return undefined
  }
}
